<header class="header"></header>
<main>
    <div class="container">
        <div class="middle-part load-data">
            <div class="form-group">
                <label>Email</label>
                <input type="text" [(ngModel)]="email" class="form-control" />
            </div>
            <div class="form-group">
                <label>Pass</label>
                <input type="password" [(ngModel)]="password" [ngModelOptions]="{standalone: true}" class="form-control" />
            </div>
            <button [ngClass]="{'btn':true, 'btn-green': true, 'btn-middle':true}" (click)=login()>
                Login
            </button>
        </div>
    </div>
</main>
